// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Preloader_spinner__22Nw0"};